import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import ReduxUseRecord from '../../../../store/actionreducers/useRecord';
import ReduxVip from '../../../../store/actionreducers/vip';
import {FuseAnimate, FusePageSimple} from '../../../../@fuse/index';
import UseRecordList from './UseRecordList';
import UseRecordSideBar from './UseRecordSideBar';
import UecareAlertDialog from "../../../../components/UecareAlertDialog";
import AddPointDialog from "./AddPointDialog"
import UecareListHeader from "../../../../components/header/UecareListHeader";
import UecareFAB from "../../../../components/UecareFAB";
import {constDataDialogs} from "../../../../constants";
import ReduxGlobal from "../../../../store/actionreducers/globalView";

class VipUseRecordApp extends Component {

    async componentDidMount() {
        try {
            const vipId = this.props.match.params.vipId;

            if (vipId === 'all') {
                await this.props.getUseRecords();
            } else {
                const vip = await this.props.getVip(vipId);
                await this.props.getUseRecordsByUserId(vip.user.id);
            }
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    render() {
        const {classes, openDataDialog} = this.props;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader
                            title='點數紀錄'
                            icon='search'
                            arrowBack={{
                                linkTo: '/apps/vip/all',
                                label: '會員列表'
                            }}/>
                    }
                    leftSidebarContent={
                        <UseRecordSideBar sidebarType='vip'/>
                    }
                    content={
                        <UseRecordList/>
                    }
                    sidebarInner
                    onRef={instance => {
                        this.pageLayout = instance;
                    }}
                />
                <FuseAnimate animation="transition.expandIn" delay={300}>
                    <UecareFAB
                        icon='add'
                        color='#249f8b'
                        onClick={() => {
                            openDataDialog({type: 'new', name: constDataDialogs.name.addPointDialog});
                        }}/>
                </FuseAnimate>
                <UecareAlertDialog/>
                <AddPointDialog/>
            </React.Fragment>
        )
    };
}

const styles = theme => ({
    root: {},
    avatar: {},
    layoutHeader: {
        height: 160,
        minHeight: 160
    },
    layoutContentCardWrapper: {
        padding: 24,
        paddingBottom: 80
    },
    layoutLeftSidebar: {
        width: 246
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        getVip: ReduxVip.ActionCreator.getVip,
        getUseRecords: ReduxUseRecord.ActionCreator.getUseRecords,
        getUseRecordsByUserId: ReduxUseRecord.ActionCreator.getUseRecordsByUserId,
    }, dispatch);
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(null, mapDispatchToProps)(VipUseRecordApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/VipUseRecordApp.js